$(".tablinks").click(function (e) {
  e.preventDefault();

  $(this)
    .parents(".TabingSection-Main")
    .find(".tablinks")
    .removeClass("active");
  $(this).addClass("active");
  var data_id = $(this).attr("data-text");
  //console.log('data_id',data_id)
  $(this)
    .parents(".TabingSection-Main")
    .find(".tabcontent")
    .removeClass("active");
  $(this)
    .parents(".TabingSection-Main")
    .find("#" + data_id)
    .addClass("active");
  $(".Category_innersec").slick("refresh");
});

// if(window.innerWidth > 991){ 

// $(".Category_innersec").slick({
//   slidesToShow: 5,
//   arrows: true,
//   prevArrow:
//     '<svg class="previocn-sec" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>',
//   nextArrow:
//     '<svg class="nextiocn-sec" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
//   dots: false,
//   slidesToScroll: 1,
//   infinite: false
// });

// }


// if(window.innerWidth < 767){ 

// $(".Category_innersecmobile").slick({
//   slidesToShow: 2,
//   arrows: true,
//   prevArrow:
//     '<svg class="previocn-sec" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>',
//   nextArrow:
//     '<svg class="nextiocn-sec" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
//   dots: false,
//   slidesToScroll: 1,
//   infinite: false
// });

// }




// Fixed Menu Section Desktop

if (window.innerWidth > 991) {
  $(window).on("scroll", function () {
    let h = $(document).scrollTop();
    if (h > 520) {
      $(".Fixedsection-menu").addClass("active");
    } else {
      $(".Fixedsection-menu").removeClass("active");
    }
  });
}

// Fixed Menu Section Mobile

if (window.innerWidth < 767) {
  $(window).on("scroll", function () {
    let h = $(document).scrollTop();
    if (h > 160) {
      $(".Fixedsection-menu").addClass("active");
    } else {
      $(".Fixedsection-menu").removeClass("active");
    }
  });
}


$(".headingsection").click(function () {
  if ($(this).hasClass("active")) {
    $(this).removeClass("active");
  } else {
    $(this).addClass("active");
  }
});

$("button.add-to-cart").click(function () {
  //$("html, body").animate({scrollTop: 350}, 1000);  
  setTimeout(function () {
    setTimeout(function () { 
      $(".CartNotifaction-Sec").removeClass("active");
    }, 3000);
    $(".CartNotifaction-Sec").addClass("active");
    var loaderhtml = $(
      `<div class="loadersec"><img src="https://cdn.shopify.com/s/files/1/0039/6073/3763/files/Innovist_loader_1.gif?v=1720105774" width="40" height="40"></div>`
    );
    var btnText = $(`<span>Add to cart</span>`);
    $(".add-to-cart").html(loaderhtml);
  
    setTimeout(function () {
      $(".add-to-cart").html(btnText);
    }, 1000);
    
  },1000);

});

$(".readmore-btn").click(function () {
  $(".pdp-description-long").show();
  $(".product_descriptionsectioninn").hide();
});

$(".readless-btn").click(function () {
  $(".pdp-description-long").hide();
  $(".product_descriptionsectioninn").show();
});


// Video Popup Section

$('.buttontext_sunscoop a').click(function(){
  $('.videoSection_popup').addClass('active');
  $('html').css('overflow', 'hidden');
  $('.videoSection_popup video').trigger('play');
})  
  
$('.close_bntvi').click(function(){
  $('.videoSection_popup').removeClass('active');
  $('html').css('overflow', 'inherit');
$('.videoSection_popup video').trigger('pause');
}) 



// CheatSheet Script Add to cart
$('tr.buttonrow_sectiontable a').click(function(){
  var dataId = $(this).data('id');

$.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        items: [{id: dataId}],
      },
      success: (data) => { 
        /*window.openGokwikSideCart();
        window.SLIDECART_UPDATE();*/
      },
      error: (err) => {
        console.error("err", err);
      },
    });  
}) 

